import React, { useEffect } from "react";
import { Chip, colors, makeStyles, Paper } from "@material-ui/core";
import { styled } from "@material-ui/styles";

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.2),
}));

export function GroupSelectRest(props) {
    const { groups,onRowClick,isMain,GroupColor,isPerm} = props;

  const selectStyle = {
    backgroundColor: !isMain ? colors.amber[900] : colors.green[300],
    color: "#fff",
    borderRadius: 10,
    fontSize:isPerm?22: 16,
    fontWeight: "bold",
  };
  const style = {
    borderRadius: 2,
    // fontSize: 14,
    fontWeight:isPerm?"bold": 600,
    fontSize:isPerm?20: 16,
    backgroundColor: !isMain ? colors.amber[100] : "",
    padding:isPerm?10:0,
  };
  return (
    <Paper
      style={{
        direction: "rtl",
        display: "flex",
        justifyContent: "right",
        overflow: "auto",
        padding: "5px",
        margin: "0px",
      }}
      component="ul"
    >
      {groups?.map((group) => {
        return (
          <ListItem key={group.id}>
            <Chip
              label={group.name}
              onClick={() => {
                onRowClick(group); 
              }}
              style={isMain?GroupColor?.id==group.id?{...style,backgroundColor: "#acf8fc"}: style:selectStyle}
            />
          </ListItem>
        );
      })}
    </Paper>
  );
}
